import React, { useEffect, useState } from 'react';

import { Button, ScrollBar, Table, WrapperFlex } from '@unimed-fesp/components';

import { BsPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as WebhookEventHeaderIntegrationActions } from '../../../store/ducks/webhookEventHeaderIntegration';
import FadeIn from '../../atoms/FadeIn';

import ModalCadastarWebhookEventHeader from '../ModalCadastarWebhookEventHeader';
import ModalCancelAction from '../ModalCancelAction';
import TableCadastroWebHookEventHeaderBody from './TableCadastroWebHookEventHeaderBody';
import TableCadastroWebHookHeader from './TableCadastroWebHookHeader';

const TableCadastroWebhookEventsHeader = ({ webhookEventId }) => {
  const dispatch = useDispatch();

  const [isEditarModal, setIsEditarModal] = useState(false);

  const [openModalCadastrarEvento, setOpenModalCadastrarEvento] =
    useState(false);

  const [openModalDeletarEvento, setOpenModalDeletarEvento] = useState({
    isOpen: false,
    eventId: '',
  });

  const {
    postWebhookEventHeader,
    putWebhookEventHeader,
    deleteWebhookEventHeader,
    getWebhookEventHeaderList,
  } = useSelector((state) => state.webhookEventHeaderIntegration);
  const headers = [
    {
      id: 2,
      title: 'Nome',
      maxWidth: '200',
      minWidth: '200',
    },
    {
      id: 3,
      title: 'Valor',
      maxWidth: '200',
      minWidth: '200',
    },
    {
      id: 4,
      title: 'Data de criação',
      maxWidth: '120',
      minWidth: '120',
    },
    {
      id: 5,
      title: 'Criado por',
      maxWidth: '120',
      minWidth: '120',
    },
    {
      id: 7,
      title: '',
      maxWidth: '150',
      minWidth: '150',
    },
  ];

  const deletarWebhookEventHeader = (webhookEventHeaderId) => {
    dispatch(
      WebhookEventHeaderIntegrationActions.deleteWebhookEventHeaderRequest(
        webhookEventHeaderId
      )
    );
    setOpenModalDeletarEvento({
      isOpen: false,
      eventId: '',
    });
  };

  useEffect(() => {
    if (
      (!postWebhookEventHeader.loading && postWebhookEventHeader.success) ||
      (!putWebhookEventHeader.loading && putWebhookEventHeader.success) ||
      (!deleteWebhookEventHeader.loading && deleteWebhookEventHeader.success)
    ) {
      dispatch(
        WebhookEventHeaderIntegrationActions.getWebhookEventHeadersListRequest(
          webhookEventId
        )
      );

      dispatch(
        WebhookEventHeaderIntegrationActions.postWebhookEventHeaderResponse(
          {},
          false
        )
      );
      dispatch(
        WebhookEventHeaderIntegrationActions.putWebhookEventHeaderResponse(
          {},
          false
        )
      );
      dispatch(
        WebhookEventHeaderIntegrationActions.deleteWebhookEventHeaderResponse(
          {},
          false
        )
      );
    }
  }, [
    postWebhookEventHeader.success,
    putWebhookEventHeader.success,
    deleteWebhookEventHeader.success,
  ]);

  useEffect(() => {
    dispatch(
      WebhookEventHeaderIntegrationActions.getWebhookEventHeadersListRequest(
        webhookEventId
      )
    );
  }, []);

  return (
    <>
      <WrapperFlex justifyEnd fullWidth>
        <Button
          tipo="primary"
          paddingTop={10}
          paddingRight={10}
          paddingBottom={10}
          paddingLeft={10}
          justifySpaceBetween
          alignCenter
          width={138}
          type="button"
          font="16px unimed_slabregular"
          onClick={() => setOpenModalCadastrarEvento(true)}
          data-testid="btn-add-contratante"
        >
          <BsPlus color="#FFFF" size="20" />
          Novo Header
        </Button>
      </WrapperFlex>
      <ScrollBar height={450} width={950}>
        <FadeIn>
          <Table head={<TableCadastroWebHookHeader headers={headers} />}>
            <TableCadastroWebHookEventHeaderBody
              isEditarModal={isEditarModal}
              setIsEditarModal={setIsEditarModal}
              openModalCadastrarHeader={openModalCadastrarEvento}
              setOpenModalCadastrarHeader={setOpenModalCadastrarEvento}
              setOpenModalDeletarHeader={setOpenModalDeletarEvento}
              webhookEventId={webhookEventId}
            />
          </Table>
        </FadeIn>
      </ScrollBar>
      <ModalCadastarWebhookEventHeader
        isOpen={openModalCadastrarEvento}
        isEditar={isEditarModal}
        onClick={() => setOpenModalCadastrarEvento(false)}
        webhookEventId={webhookEventId}
        setIsEditarModal={setIsEditarModal}
      />
      <ModalCancelAction
        isOpen={openModalDeletarEvento.isOpen}
        onClickOk={() =>
          deletarWebhookEventHeader(openModalDeletarEvento.eventId)
        }
        onClick={() =>
          setOpenModalDeletarEvento({
            isOpen: false,
            eventId: '',
          })
        }
        text="O Header será excluído."
        textHeader="Excluir Header"
        loading={getWebhookEventHeaderList.loading}
      />
    </>
  );
};

export default TableCadastroWebhookEventsHeader;
